import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { createShop } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   Title,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledButton,
   ButtonContainer,
   ButtonWrapper,
   Message,
} from "./NewShop.styles"

const NewShop = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [shopInputs, setShopInputs] = useState({})

   const handleChange = (e) => {
      setShopInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await createShop(shopInputs, dispatch)
      if (res === "success") {
         navigate("/shops")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <Title>New Shop</Title>
               <StyledForm>
                  <FormItem>
                     <StyledLabel>Customer Code</StyledLabel>
                     <StyledInput
                        type="text"
                        name="customerCode"
                        placeholder="123456"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Name</StyledLabel>
                     <StyledInput
                        type="text"
                        name="name"
                        placeholder="Optique Toto"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Address</StyledLabel>
                     <StyledInput
                        type="text"
                        name="address"
                        placeholder="700 Les Roches"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Zip code</StyledLabel>
                     <StyledInput
                        type="text"
                        name="zip"
                        placeholder="39270"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>City</StyledLabel>
                     <StyledInput
                        type="text"
                        name="city"
                        placeholder="Alièze"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Email</StyledLabel>
                     <StyledInput
                        type="text"
                        name="mail"
                        placeholder="contact@losersmagnifiques.com"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Phone</StyledLabel>
                     <StyledInput
                        type="text"
                        name="phone"
                        placeholder="+33 123 456 789"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Latitude</StyledLabel>
                     <StyledInput
                        type="number"
                        name="lat"
                        placeholder="46.587908"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Longitude</StyledLabel>
                     <StyledInput
                        type="number"
                        name="lng"
                        placeholder="5.590063"
                        onChange={handleChange}
                     />
                  </FormItem>
               </StyledForm>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Create</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default NewShop
